export default __webpack_public_path__ + "static/media/x.0c9dfca1.svg";